import { ImgHTMLAttributes, useState } from 'react';
import { Avatar } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  name: string;
  dimension: number;
  isRound?: boolean;
  alt: string;
  isDecorative?: boolean;
}

export default function ImageWithFallback({
  name,
  dimension,
  isRound = false,
  src,
  alt,
  isDecorative = false,
  ...props
}: Props) {
  const theme = useTheme();
  const { main: primaryMain } = theme.palette.primary;
  const [isFallback, setIsFallback] = useState(false);
  const onError = () => {
    setIsFallback(true);
  };

  const initials = name
    .split(' ')
    .map((n: string) => n[0])
    .join('');

  return (
    <>
      {isFallback && (
        <Avatar
          variant={isRound ? 'circular' : 'rounded'}
          aria-hidden={isDecorative ? true : undefined}
          sx={{
            bgcolor: primaryMain,
            color: '#fff',
            width: dimension,
            height: dimension,
            ...theme.mixins.commonGradient({ variant: 'blue' }),
          }}
        >
          {initials}
        </Avatar>
      )}
      {!isFallback && (
        <img
          {...props}
          id={
            isDecorative
              ? undefined
              : props.id !== undefined && props.id !== ''
                ? props.id
                : undefined
          }
          src={src}
          aria-hidden={isDecorative ? true : undefined}
          alt={isDecorative ? '' : alt}
          style={{
            width: dimension,
            height: dimension,
            overflow: 'hidden',
            borderRadius: isRound ? '50%' : '4px',
            objectFit: 'cover',
          }}
          onError={onError}
        />
      )}
    </>
  );
}
